module.exports = __webpack_public_path__ + "static/img/jddj.a91f716.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jddj.svg
// module id = 6KJX
// module chunks = 2